import { put, takeEvery } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { changeIdentityRole, switchRole } from '../actions'
import { switchUsersTab } from 'store/entities/organizations/actions'
import { USERS } from 'app/constants/organizations.js'

export default function* switchRoleSaga() {
  yield takeEvery(switchRole.toString(), changeRoleAndRedirect)
}

export function* changeRoleAndRedirect(action) {
  yield put(changeIdentityRole(action.payload.roleIndex))
  // switch users tab setting to default
  yield put(switchUsersTab(USERS))
  yield put(push('/'))
}
